import React from 'react';
import * as Icons from 'lucide-react';
import { ArrowUpRight } from 'lucide-react';

export default function FeatureCard({ title, desc, icon, highlight, index }) {
  const Icon = Icons[icon] || Icons.Sparkles;
  return (
    <div
      className={`feature-card fade-in group relative rounded-2xl p-7 border ${highlight ? 'bg-white border-[#22c55e] shadow-[0_4px_18px_-8px_rgba(34,197,94,0.4)]' : 'bg-white border-neutral-200'}`}
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-5 transition-all duration-500 ${highlight ? 'bg-[#22c55e] group-hover:rotate-6' : 'bg-neutral-100 group-hover:bg-[#22c55e]'}`}>
        <Icon className="w-8 h-8 text-black" strokeWidth={2} />
      </div>
      <h3 className="text-[19px] font-black text-black mb-2.5 leading-snug">{title}</h3>
      <p className="text-sm text-neutral-600 leading-relaxed mb-5">{desc}</p>
      <a href="#" className="inline-flex items-center gap-1 text-sm font-bold text-black hover:text-[#16a34a] transition-colors">
        Learn more <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
      </a>
    </div>
  );
}
